"use strict";

var _regeneratorRuntime = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.associated = exports.findProgramAddressSync = exports.createProgramAddressSync = exports.createWithSeedSync = void 0;

var buffer_1 = require("buffer");

var bn_js_1 = __importDefault(require("bn.js"));

var js_sha256_1 = require("js-sha256");

var web3_js_1 = require("@solana/web3.js");

var common_js_1 = require("../program/common.js"); // Sync version of web3.PublicKey.createWithSeed.


function createWithSeedSync(fromPublicKey, seed, programId) {
  var buffer = buffer_1.Buffer.concat([fromPublicKey.toBuffer(), buffer_1.Buffer.from(seed), programId.toBuffer()]);
  var hash = js_sha256_1.sha256.digest(buffer);
  return new web3_js_1.PublicKey(buffer_1.Buffer.from(hash));
}

exports.createWithSeedSync = createWithSeedSync; // Sync version of web3.PublicKey.createProgramAddress.

function createProgramAddressSync(seeds, programId) {
  var MAX_SEED_LENGTH = 32;
  var buffer = buffer_1.Buffer.alloc(0);
  seeds.forEach(function (seed) {
    if (seed.length > MAX_SEED_LENGTH) {
      throw new TypeError("Max seed length exceeded");
    }

    buffer = buffer_1.Buffer.concat([buffer, toBuffer(seed)]);
  });
  buffer = buffer_1.Buffer.concat([buffer, programId.toBuffer(), buffer_1.Buffer.from("ProgramDerivedAddress")]);
  var hash = (0, js_sha256_1.sha256)(new Uint8Array(buffer));
  var publicKeyBytes = new bn_js_1.default(hash, 16).toArray(undefined, 32);

  if (web3_js_1.PublicKey.isOnCurve(new Uint8Array(publicKeyBytes))) {
    throw new Error("Invalid seeds, address must fall off the curve");
  }

  return new web3_js_1.PublicKey(publicKeyBytes);
}

exports.createProgramAddressSync = createProgramAddressSync; // Sync version of web3.PublicKey.findProgramAddress.

function findProgramAddressSync(seeds, programId) {
  var nonce = 255;
  var address;

  while (nonce != 0) {
    try {
      var seedsWithNonce = seeds.concat(buffer_1.Buffer.from([nonce]));
      address = createProgramAddressSync(seedsWithNonce, programId);
    } catch (err) {
      if (err instanceof TypeError) {
        throw err;
      }

      nonce--;
      continue;
    }

    return [address, nonce];
  }

  throw new Error("Unable to find a viable program address nonce");
}

exports.findProgramAddressSync = findProgramAddressSync;

var toBuffer = function toBuffer(arr) {
  if (arr instanceof buffer_1.Buffer) {
    return arr;
  } else if (arr instanceof Uint8Array) {
    return buffer_1.Buffer.from(arr.buffer, arr.byteOffset, arr.byteLength);
  } else {
    return buffer_1.Buffer.from(arr);
  }
};

function associated(_x) {
  return _associated.apply(this, arguments);
}

function _associated() {
  _associated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(programId) {
    var seeds,
        _len,
        args,
        _key,
        _yield$web3_js_1$Publ,
        _yield$web3_js_1$Publ2,
        assoc,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            seeds = [buffer_1.Buffer.from([97, 110, 99, 104, 111, 114])]; // b"anchor".

            for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = _args[_key];
            }

            args.forEach(function (arg) {
              seeds.push(arg instanceof buffer_1.Buffer ? arg : (0, common_js_1.translateAddress)(arg).toBuffer());
            });
            _context.next = 5;
            return web3_js_1.PublicKey.findProgramAddress(seeds, (0, common_js_1.translateAddress)(programId));

          case 5:
            _yield$web3_js_1$Publ = _context.sent;
            _yield$web3_js_1$Publ2 = _slicedToArray(_yield$web3_js_1$Publ, 1);
            assoc = _yield$web3_js_1$Publ2[0];
            return _context.abrupt("return", assoc);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _associated.apply(this, arguments);
}

exports.associated = associated;